import { useShop } from "@/store/ShopContext";

export default function ToastHost() {
  const { toast } = useShop();
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[70] pointer-events-none">
      <div
        className={`px-5 py-3 rounded-full bg-foreground-950 text-background-50 text-[13.5px] font-medium shadow-lg transition-all duration-300 ${
          toast ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
        }`}
      >
        <span className="inline-flex items-center gap-2 whitespace-nowrap">
          <i className="ri-checkbox-circle-fill text-accent-300 text-[16px]"></i>
          {toast?.message ?? ""}
        </span>
      </div>
    </div>
  );
}